// src/context/MeetingContext.js
import React, { createContext, useState } from 'react';

export const MeetingContext = createContext({
  currentMeeting: null,
  setCurrentMeeting: () => {}
});

export const MeetingProvider = ({ children }) => {
  const [currentMeeting, setCurrentMeeting] = useState(null);

  return (
    <MeetingContext.Provider value={{ currentMeeting, setCurrentMeeting }}>
      {children}
    </MeetingContext.Provider>
  );
};